module.exports = __webpack_public_path__ + "img/img (20).8030440c.jpg";